import { SvgIconProps } from 'ui/icons/SvgIcon';

import { EventName } from '../../domain';
import { getEventIcon } from '../utils';

type EventIconProps = SvgIconProps & {
  eventName: EventName;
};

export const EventIcon = ({ eventName, ...svgIconProps }: EventIconProps) => {
  const Icon = getEventIcon(eventName);

  return <Icon {...svgIconProps} />;
};
